import { Helmet } from 'react-helmet-async';
import { fitTitle, fitDescription, getTitlePixelWidth, MAX_TITLE_PX } from '../lib/seoWidth';

export default function SEOHead({
  title = 'Autotransport og autohjælp i hele Danmark | MC Transport',
  description = 'MC Transport tilbyder professionel autotransport, autohjælp 24/7, bjærgning og bugsering i hele Danmark. Ring til vagtcentralen på 70 700 800.',
  canonicalUrl,
  ogImage = 'https://assets.auxodev.dk/assets/7ab2fd9d-1ad5-42a7-a15d-22229bea7818/roed-volvo-autotransport-med-7-biler-18-03-2025-379.jpeg',
  schemaData = null
}) {
  // Determine final title: include brand if it fits within 512 px
  let resolvedTitle = String(title || '').trim();
  if (!resolvedTitle.includes('MC Transport')) {
    const withBrand = `${resolvedTitle} | MC Transport`;
    if (getTitlePixelWidth(withBrand) <= MAX_TITLE_PX) {
      resolvedTitle = withBrand;
    }
  }

  // Ensure title is strictly <= 512 px
  const finalTitle = fitTitle(resolvedTitle, MAX_TITLE_PX);
  // Ensure description is strictly <= 970 px
  const finalDescription = fitDescription(description, 970);

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MC Transport" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
}
